import styled from 'styled-components';

const SkeletonLineStyled = styled.div<{ width?: string; borderRadius?: string; height?: string; margin?: string }>`
  display: inline-block;
  min-height: 0.5rem;
  background: linear-gradient(-90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
  background-size: 400% 400%;
  animation: pulse 1.2s ease-in-out infinite;
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
  width: ${({ width }) => (width ? width : '5.5em')};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '5px')};
  height: ${({ height }) => (height ? height : '100%')};
  ${({ margin }) => margin && `margin: ${margin}`};
`;

const EstateCardSkeletonStyled = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: auto;
  border: none;
  justify-content: flex-start;
  font-size: 5em;
  background: #ffffff;
  box-shadow: 0px 10px 25px #7878780f;
  border-radius: 24px;
  color: ${(props) => props.color};
  min-width: 275px;
  max-width: 444px;
  min-height: 313px;
  cursor: pointer;
  margin: auto;
  margin-bottom: 16px;
  overflow: hidden;
  gap: 10px;
`;

const LineBox = styled.div<{ align?: string }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
  overflow: hidden;
  justify-content: ${({ align }) => (align ? align : 'flex-start')};
`;

export { SkeletonLineStyled, EstateCardSkeletonStyled, LineBox };
